// extracted by mini-css-extract-plugin
module.exports = {"product-brief-guide-swiper":"Swiper_product-brief-guide-swiper__SuF70"};